import * as t from "io-ts";
import { createCargoViewTypes } from "dora-contracts";

export const { cargoViewT, cargoViewsT, cargoViewStopT } = createCargoViewTypes(
  { decimal: t.string, dateTime: t.string }
);

export type Stop = t.TypeOf<typeof cargoViewStopT>;
export type CargoView = t.TypeOf<typeof cargoViewT>;
